import { Component, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { Device, DeviceType } from '@era/locations-sdk';

import { AsyncPipe } from '@angular/common';
import { DeviceStoreSelectors } from '@era/stores';
import { DeviceActionBarComponent } from '@rocksoft/cdk';
import { AppleDeviceContainerComponent } from '@rocksoft/shared';

@Component({
  selector: 'era-devices-in-room',
  templateUrl: './devices-in-room.container.html',
  styleUrls: ['./devices-in-room.container.scss'],
  imports: [AppleDeviceContainerComponent, DeviceActionBarComponent, AsyncPipe],
})
export class DevicesInRoomContainerComponent {
  public readonly devices$: Observable<Device[]>;
  public readonly appleDevices$: Observable<Device[]>;

  @Input() roomUniqueId: string;
  constructor(store: Store<Device>) {
    this.devices$ = store.select(DeviceStoreSelectors.selectDevicesForCurrentRoom);
    this.appleDevices$ = this.devices$.pipe(map((x) => x.filter((y) => y.deviceType === DeviceType.Apple)));
  }
}
